import {ValueResolver} from '@/engine';
import {InvestorAccount} from '@/types/client-info';
import {mapAccountTypeToDomainValue} from '@/utils/client-info/mappers';

export const getDocumentTypeFromAccount = (
  account: InvestorAccount | undefined,
  domainValueResolver: ValueResolver,
  defaultType: string,
): string => {
  if (!account) return defaultType;

  const accountType = mapAccountTypeToDomainValue(account?.acctType || '');
  if (accountType) {
    return domainValueResolver(accountType);
  }

  return defaultType;
};
